export type PublicLink = {
	isEnabled: boolean;
	isEditEnabled: boolean;
	refetch: Function;
};

export class PublicLinkService {
	private publicLink: PublicLink = {
		isEnabled: false,
		isEditEnabled: false,
		refetch: () => {},
	};

	setPublicLink(publicLink: PublicLink) {
		this.publicLink = publicLink;
	}

	getPublicLink(): PublicLink | undefined {
		return this.publicLink;
	}

	refetchPublicLink() {
		this.publicLink.refetch();
	}
}
